export enum ImageType {
    Website = 0,
    Gallery = 1,
    Signage = 2,
    Logo = 3,
    CustomerDisplay = 4,
}
